// extracted by mini-css-extract-plugin
module.exports =  {"xl":"Icon__xl","lg":"Icon__lg","md":"Icon__md","sm":"Icon__sm"};